import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconSettings } from "@tabler/icons-react";
import { cn } from "../../lib/utils";
import { InterestsSheet } from "../interests/InterestsSheet";
import { TAB_BAR_LAYOUTS, type TabBarLayout } from "../ui/TabButton";

/**
 * Gear chip in the Discovery tab bar that opens the "Pick your interests"
 * bottom sheet. Interests are curated, specialty-scoped JuisciTopics (the
 * closed vocabulary that replaced the old MeSH-term picker). On desktop it is
 * the Figma desktop settings `.TabChip`, a 32px square.
 */
function DiscoveryInterestsSheet({
  layout,
}: {
  layout: TabBarLayout;
}): React.JSX.Element {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label={t("Pick your interests")}
        onClick={() => {
          setOpen(true);
        }}
        className={cn(
          "flex shrink-0 cursor-pointer items-center justify-center bg-ds-slate-50 text-ds-mint-950",
          layout === "desktop" ? "size-8 rounded-lg" : "size-10 rounded-xl"
        )}
      >
        <IconSettings size={16} stroke={TAB_BAR_LAYOUTS[layout].iconStroke} />
      </button>
      <InterestsSheet
        isOpen={isOpen}
        onClose={() => {
          setOpen(false);
        }}
      />
    </>
  );
}

export { DiscoveryInterestsSheet };
